import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoryImgSliderComponent } from './components/story-img-slider/story-img-slider.component';
import { NgxGlideModule } from 'ngx-glide';



@NgModule({
  declarations: [
    StoryImgSliderComponent
  ],
  imports: [
    CommonModule,
    NgxGlideModule
  ],
  exports: [
    StoryImgSliderComponent
  ]
})
export class StoryImgSliderModule { }
